import React, { useRef } from 'react';
var VeltCommentsSidebarV2Header = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-header-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2Header;
